import api from '@/api'
export default {
  // 批量导入球队运动数据Excel
  batchAddPlayerBodyData (data) {
    return api({
      url: '/playerBodyData/import/excel',
      method: 'POST',
      data
    })
  },
  getBodySystem (params) {
    return api({
      url: '/playerBodyData/BodyDataListSystem',
      method: 'GET',
      params
    })
  },
  getBodyOrgan (params) {
    return api({
      url: '/playerBodyData/BodyDataListOrgan',
      method: 'GET',
      params
    })
  },
  getBodyYouth (params) {
    return api({
      url: '/playerBodyData/BodyDataListYouth',
      method: 'GET',
      params
    })
  },
  getBodyLeaderOrCoach (params) {
    return api({
      url: '/playerBodyData/BodyDataListCoachOrLeader',
      method: 'GET',
      params
    })
  },
  deleteRemoveBoby (params) {
    return api({
      url: '/playerBodyData/BodyDataRemove',
      method: 'POST',
      params
    })
  },
  // 获取根据dataUuid查询测试详情
  getBodyDataInfo (uuid) {
    return api({
      url: `/playerBodyData/bodyDataInfo/${uuid}`,
      method: 'GET'
    })
  },
  // 查询某个球员的测试
  getPlayerBodyData (playerUuid, params) {
    return api({
      url: `/playerBodyData/bodyDataList/${playerUuid}`,
      method: 'GET',
      params
    })
  },
  // 获取测试数据模板/指标
  getTemplate () {
    return api({
      url: '/playerBodyData/BodyDataTemplateToIndicatorList',
      method: 'GET'
    })
  },
  
  // 获取测试数据模板/指标 技术支持调用 官方的
  getTemplateSuper () {
    return api({
      url: '/playerBodyData/BodyDataTemplateToIndicatorListSuper',
      method: 'GET'
    })
  },

  // 获取运动能力排名列表
  getplayerBodyDataListSearch(params={}) {
    return api({
      url: '/playerBodyData/bodyDataListSearch',
      method: 'GET',
      params
    })
  },

  /* 获取运动员详细信息 */
  getplayerInfo( params={} ) {
    const {dataUuid, playerUuid} = params;
    return api({
      url: `/playerBodyData/playerBodyDataInfo/${dataUuid}/${playerUuid}`,
      method: 'GET',
    })
  },
  /* 筛选的时候 根据年份查一下都有几岁 */
  bodyDataListSearch( params={} ) {
    const {year} = params;
    return api({
      url: `/playerBodyData/bodyDataAgeListSearch/${year}`,
      method: 'GET',
    })
  }
}
